import React, { useContext } from "react";

// Custom
import UserContext from "@/components/UserContext/UserContext";
import DataCentricPage from "@/views/DataCentric/DataCentricPage";
import modelComments from "@/models/komentari";
import modelStaze from "@/models/staze"; 
import CommentDialog from "@/views/Komentari/CommentDialog";
import StazaDialog from "./StazaDialog";
import { Permissions } from "@/lib/permissions";
import { OwnerOrganisations } from "@/lib/ownerOrganisations";


// Types
import { DCRecord } from "@/@types/lib/dataController";

function StazePage() {
  const userContext = useContext(UserContext);

  const defineStazeForm = (record: DCRecord) => {

    const recordOwnerId = record.owner_organisation as number; // 20 za hgss, 30 za hps

    if (userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HGSSRead])) {
      if (recordOwnerId === OwnerOrganisations.HGSS.code) {
        return "hgss_user_on_hgss_data"
      }
      if (recordOwnerId === OwnerOrganisations.HPS.code) {
        return "hgss_user_on_hps_data"
      }
      console.warn("how did u get here? 1")
      return "edit"
    }
    if (userContext?.hasAnyPermission([Permissions.HPSMod, Permissions.HPSRead])) {
      if (recordOwnerId === OwnerOrganisations.HGSS.code) {
        return "hps_user_on_hgss_data"
      }
      if (recordOwnerId === OwnerOrganisations.HPS.code) {
        return "hps_user_on_hps_data"
      }
      console.warn("how did u get here? 2")
      return "edit"
    }
    console.log("how did u get here? 3")
    return "edit"
  };

  const defineStazeView = () => {
    if (userContext?.organisationId === OwnerOrganisations.HGSS.code) {
      return 'hgss';
    }
    if (userContext?.organisationId === OwnerOrganisations.HPS.code) {
      return 'hps';
    }
    return 'reg';
  }

  const komentriForm = userContext?.hasAnyPermission([Permissions.HGSSMod]) ? "update-hgss"
  : userContext?.hasAnyPermission([Permissions.HPSMod]) ? "update-hps" 
  : "default";


  const allowView = userContext?.hasAnyPermission([Permissions.HGSSRead, Permissions.HPSRead]);
  const allowEdit = userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HPSMod]);

  const hasAdminRights = userContext?.hasAnyPermission([Permissions.HGSSMod, Permissions.HPSMod]);

  return (
    <DataCentricPage
      needPermission={[Permissions.HGSSRead, Permissions.HPSRead, Permissions.HPSSharedView]}

      primaryModel={modelStaze}
      primaryTitleToken="titles.staze"
      primaryView={defineStazeView()}
      primaryAllowView={allowView}
      primaryAllowEdit={allowEdit}
      primaryDialogComponent={StazaDialog}
      primaryDialogForm={defineStazeForm}

      secondaryModel={modelComments}
      secondaryTitleToken={hasAdminRights ? "titles.komentari" : "titles.komentari_moji"}
      secondaryView={hasAdminRights ? "related_komentari" : "my_related_komentari"}
      secondaryAllowView={allowView}
      secondaryAllowEdit={allowEdit}
      secondaryDialogComponent={CommentDialog}
      secondaryDialogForm={komentriForm}

      baseRecordPath={modelStaze.apiPath}      
      childRecordRelativePath="komentari"
      geomRelativePath="geom"

      mapId={7}
      mapModel={modelStaze}

    />
  );
}

export default StazePage;
